import { isValidUriPath } from "~/lib/utils";
import BasicMarker from "./BasicMarker";
import CustomMarker from "./CustomMarker";
import EmojiMarker from "./EmojiMarker";
import type { PointStyles } from "~/types";

export const MarkerMap = new Map([
  ["basic", BasicMarker],
  ["emoji", EmojiMarker],
  ["custom", CustomMarker],
]);

export default function MarkerContent({ styles }: { styles: PointStyles }) {
  const { icon } = styles;

  const isImage = isValidUriPath(icon);
  const markerType = isImage
    ? "custom"
    : icon.startsWith("emoji")
    ? "emoji"
    : "basic";

  const MarkerContent = MarkerMap.get(markerType);

  if (!MarkerContent) return null;

  return <MarkerContent {...styles} />;
}
